import { FCRAWorker } from '@/types/turn-api';

export const transformSubmitData = (data: FCRAWorker.Details) => {
  // NOTE: inject ssn_new value into ssn for update
  if (data.ssn_new?.trim()) data.ssn = data.ssn_new.trim();
  delete data.ssn_new;
  return data;
};
